import React, { useEffect, useState } from "react";
import SliderWeb from "./slider/slider";
import './contactUs.css';
import { GetContactUs } from '../../utils/api'
import Loader from '../../components/loader/dotloader'


//icon
import Email from '../../assets/icons/contact/email.svg'
import Phone from '../../assets/icons/contact/phone.svg'
import Instagram from '../../assets/icons/contact/instagram.svg'
import LeafBg from '../../assets/images/leaf-bg.svg'

const ContactUs = () => {
    const [loading, setLoading] = useState(false)
    const [contactList, setContactList] = useState(null)

    const getContactData = async () => {
        // setLoading(true)
        try {
            let data = await GetContactUs()
            setContactList(data.data)

        } catch (error) {

        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        setTimeout(() => {
            getContactData()
            
        }, 1500);
    }, [])
    function convertToPersianNumbers(input) {
        if (input) {

            const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
            return input.replace(/\d/g, (digit) => persianDigits[digit]);
        }
    }
    return (

        <>
            {loading && <Loader isLoading={loading} />}

            <div className='container  mt-5 px-0'>

                <SliderWeb />
            </div>
            <div className="contact-item mt-5 ">
                <img src={LeafBg} alt="" className='web' style={{ position: 'absolute', right: '0', top: '3em' }} />
                <a className="item" href={`mailto:${contactList?.email}`}>
                    <div className="img-box">
                        <img src={Email} alt="" />
                    </div>
                    <h6 className="text-[#00a14b] text-lg font-bold">{convertToPersianNumbers(contactList?.email)}</h6>

                </a>
                <a className="item" href={contactList?.insta} target='_blank'>
                    <div className="img-box">
                        <img src={Instagram} alt="" />
                    </div>
                    <h6 className="text-[#00a14b] text-lg font-bold">benicejuice</h6>

                </a>
                <a className="item" href={`tel:${contactList?.phone}`}>
                    <div className="img-box">
                        <img src={Phone} alt="" />
                    </div>
                    <h6 className="text-[#00a14b] text-lg font-bold">{convertToPersianNumbers(contactList?.phone)}</h6>

                </a>

            </div>
        </>
    );
};

export default ContactUs;
